import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CadastrarAnexoCadastroModalComponent } from './cadastrar-anexo-cadastro-modal/cadastrar-anexo-cadastro-modal.component';
import { AnexoCadastro } from '../../models/anexo-cadastro';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { DocumentosService } from 'src/app/services/documentos.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { Documento } from 'src/app/models/documento';

declare const $: any;

@Component({
  selector: 'app-anexo-cadastro-modal',
  templateUrl: './anexo-cadastro-modal.component.html',
  styleUrls: ['./anexo-cadastro-modal.component.scss']
})
export class AnexoCadastroModalComponent implements OnInit {
  anexos: AnexoCadastro[] = [];
  public config: PerfectScrollbarConfigInterface = {};

  idTipoDocumentoContato = 0;
  documentos: Documento[] = [];
  existeArquivoContrato = false;

  constructor(private dialog: MatDialog,
              public dialogRef: MatDialogRef<AnexoCadastroModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private utilitarioService: UtilitarioService,
              private carregandoService: CarregandoService,
              private documentoService: DocumentosService,
              private notificacaoService: NotificacaoService
  ) {
    this.anexos = this.data.anexos;
    this.existeArquivoContrato = this.data.existeArquivoContrato;
    this.documentos = this.data.documentos;

  }

  ngOnInit(): void {
    if (!(this.anexos && this.anexos.length && this.documentos && this.documentos.length)) {
      this.buscarDocumentosAnexo();
    }
  }

  buscarDocumentosAnexo() {
    this.carregandoService.mostra('buscarDocumentosAnexo');

    this.documentoService.consultarDocumentos(this.idTipoDocumentoContato).subscribe(
      docs => {
        this.documentos = docs;

        this.montarAnexos();

        this.carregandoService.esconde('buscarDocumentosAnexo');
      },
      err => {
        this.carregandoService.esconde('buscarDocumentosAnexo');
        this.notificacaoService.erro(err);
      }
    );
  }

  montarAnexos() {
    this.anexos = this.documentos.map(p => {
      const anx = new AnexoCadastro();
      anx.idDocumento = p.id;
      anx.descricao = p.titulo;
      anx.contrato = false;
      return anx;
    });

    if (this.existeArquivoContrato) {
      const documentoContrato = new Documento();

      documentoContrato.tipo = 0;
      documentoContrato.titulo = 'Contrato de parceria';
      documentoContrato.descricao = 'Baixe, assine e faça o upload';
      documentoContrato.obrigatorio = true;

      this.documentos = [
        documentoContrato, ...this.documentos
      ];

      const anexoContrato = new AnexoCadastro();

      anexoContrato.descricao = documentoContrato.titulo;
      anexoContrato.contrato = true;

      this.anexos = [
        anexoContrato, ...this.anexos
      ];
    }
  }


  verificarSeTemObrigatorioSemArquivo() {
    return this.anexos.some((p, i) => !p.arquivo && this.documentos[i].obrigatorio);
  }

  fechar() {
    this.dialogRef.close(
      {
        anexos: this.anexos,
        documentos: this.documentos,
        erroDocumentosObrigatorios: this.verificarSeTemObrigatorioSemArquivo()
      }
    );
  }
}
